<template>
  <v-sheet
    class="d-flex justify-center align-center py-10 py-md-13 py-lg-16"
    height="100%"
    width="100%"
    color="transparent"
  >
    <v-progress-circular
      :size="50"
      :color="color"
      indeterminate
    ></v-progress-circular>
  </v-sheet>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
    },
  },
};
</script>
